<div class="about-shell">
  <mat-tab-group class="bpx-tab-host">
    <mat-tab label="Audit Trail" i18n i18n-label>
      <app-audit-trail></app-audit-trail>
    </mat-tab>
    <mat-tab label="Users" i18n i18n-label [disabled]="(isSuperUser$ | async) === false">
      <app-users></app-users>
    </mat-tab>
  </mat-tab-group>
</div>
